export const GOVERNANCE_DECISION_JOURNEY_STAGES = Object.freeze([
  Object.freeze({ id: 'review-authorize', label: 'Review / Authorize', module: 'Board Decisions', route: '/board-decisions' }),
  Object.freeze({ id: 'execute', label: 'Execute', module: 'Program Control Tower', route: '/investment-monitoring' }),
  Object.freeze({ id: 'measure', label: 'Measure', module: 'Outcome Measurement', route: '/benefits-governance' }),
  Object.freeze({ id: 'govern-reassess', label: 'Govern / Reassess', module: 'Investment Governance', route: '/investment-governance' }),
])

export function getGovernanceDecisionJourneyStage(stageId) {
  return GOVERNANCE_DECISION_JOURNEY_STAGES.find(({ id }) => id === stageId)
}
